
import React, { useEffect, useRef, useState } from "react";
import { Dropdown , Tab } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { expensePolicyDetailInitialsForUpdate } from "./interfaces/expensePolicyDetailClass";
import { GetDataByAccountExpensePolicyIdAsync, resetSelectedRecordObjectInState,updatePagination } from "./expensePolicyDetailSlice";
import ExpensePolicyDetailItem from "./ExpensePolicyDetailItem";
import { Link, useLocation } from 'react-router-dom';
import { json } from "stream/consumers";
import ExpensePolicyGeneralForm from "./ExpensePolicyGeneralForm";
import ExpensePolicyCategoryForm from "./ExpensePolicyCategoryForm";
import clsx from 'clsx';
import ExpensePolicyRule from "../expensePolicyRule/ExpensePolicyRule";
import ExpensePolicyPerDiem from "../expensePolicyPerDiem/ExpensePolicyPerDiem";
import ExpensePolicyLockingExpenses from "../expensePolicyLockingExpenses/ExpensePolicyLockingExpenses";
import ExpensePolicyDetailOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from "../../../common/Toastr";
import ExpensePolicyRuleForm from "../expensePolicyRule/ExpensePolicyRuleForm";
import ExpensePolicyLockingExpensesForm from "../expensePolicyLockingExpenses/ExpensePolicyLockingExpensesForm";
import ExpensePolicyPerDiemForm from "../expensePolicyPerDiem/ExpensePolicyPerDiemForm";
import Select, { StylesConfig } from 'react-select';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/Pagination";
import { FormatInvoiceDecimalNumber, getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}
const itemClass = 'ms-1 ms-lg-0';

const ExpensePolicyDetail = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { expensePolicyDetailList, isReload,isLoading,selectedRecord, sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.expensePolicyDetail);
    const { expensePolicyRuleList, selectedRecord: ruleSelectedRecord } = useAppSelector((state) => state.expensePolicyRule);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, cultureInfoName,decimalPlaces } = useAppSelector((state) => state.globalState);
    const { MasterExpensePolicyId } = useAppSelector((state) => state.expensePolicy);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isGeneralLimitModalOpen, setIsGeneralLimitModalOpen] = useState<boolean>(false);
    const [isPolicyCategoryModalOpen, setIsPolicyCategoryModalOpen]= useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();
    const CategorymodelRef = useRef<any>(null);
    const { obj } = location.state || {};
    
    const storedObjectData = localStorage.getItem('objExpensePolicyItem');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    

    // const { AccountExpensePolicyId } = objectData;


    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
     if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
     } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
     } else if(objectData && objectData.AccountExpensePolicyId){
        AccountExpensePolicyId = objectData.AccountExpensePolicyId;
     }else
     {
         navigate('../expensepolicy');
     }

    const [tab, setTab] = useState('ExpenseCategoryLimits');
    
    const openModalGeneralLimit = () => {
        setIsGeneralLimitModalOpen(true);
    };

    const closeModalGeneralLimit = () => {
        setIsGeneralLimitModalOpen(false);
    };

     
    const openModalPolicyCategory = () => {
        setIsPolicyCategoryModalOpen(true);
    };

    const closeModalPolicyCategory = () => {
        setIsPolicyCategoryModalOpen(false);
    };

    // const offCanvasList = [
        
    //     {
    //         "name": (t('Add Expense Rule')),
    //         // "name": (Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')) ,
    //         "width": "700px",
    //         "componentName": <ExpensePolicyRuleForm />
    //     },
    //     {
    //         "name": (Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add') + " Locking Expense",
    //         "width": "700px",
    //         "componentName": <ExpensePolicyLockingExpensesForm />
    //     },
    //     {
           
    //         "width": "700px",
    //         "componentName": <ExpensePolicyPerDiemForm />
    //     }
    // ];

    // const [showOffCanvas, setShowOffCanvas] = useState(false);
    // const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]); 
    const offCanvasList = [
        {
            "name": (Object.keys(ruleSelectedRecord).length > 0 ? 
            // t('Update')
            getValueFromResource('Update ',dispatch, t) : getValueFromResource('Add ',dispatch, t))  + ' ' +  getValueFromResource('Expense Rule',dispatch, t),
            "width": "700px",
            "componentName": <ExpensePolicyRuleForm />
        },
        {
            "name": (Object.keys(selectedRecord).length > 0 ? 
            // 'Update'
            getValueFromResource('Update ',dispatch, t)
             : 
            //  'Add') 
            getValueFromResource('Add ',dispatch, t))
             + 
            //  " Locking Expense",
            getValueFromResource('Delete',dispatch, t),

            "width": "700px",
            "componentName": <ExpensePolicyLockingExpensesForm />
        },
        {
            "width": "700px",
            "componentName": <ExpensePolicyPerDiemForm />
        }
    ];
 
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]);
 
    useEffect(() => {
        setSelectedOffCanvas(offCanvasList[0]);
    }, [ruleSelectedRecord]);

    const handleOnClickEvent = (selectedObject:any) => {
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }
  
    
    useEffect(() => {
        if (isReload) {
            dispatch(GetDataByAccountExpensePolicyIdAsync(AccountExpensePolicyId));         
        }
    }, [isReload])
    useEffect(() => {
        dispatch(GetDataByAccountExpensePolicyIdAsync(AccountExpensePolicyId)); 
    }, [dispatch])

    let stateItem: any = {}
    const tempObj: any = selectedRecord;


 

      const onEditClick = (AccountExpensePolicyId: string) => {
        dispatch(GetDataByAccountExpensePolicyIdAsync(AccountExpensePolicyId))
            .unwrap()
            .then((originalPromiseResult) => {
                openModalGeneralLimit();
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('GetDataByAccountExpensePolicyIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };
    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTerm(value);
    //     setCurrentPage(1);
    // };

    // const handlePageSizeChange = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     setPageSize(Number(value));
    //     setCurrentPage(1);
    // };

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    // const filteredData: any = getFilteredList(expensePolicyDetailList, searchTerm);

    
    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = expensePolicyDetailList.length;
    // const recordsFiltered = filteredData.length;


    const filteredData: any = getFilteredList(expensePolicyDetailList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = expensePolicyDetailList.length;
    const recordsFiltered = filteredData.length;



       return (
        <>

{isLoading && <Loader />}

        <div className='card-header card-header-stretch overflow-auto'>
                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap '  role='tablist'>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'ExpenseCategoryLimits' })}
                                    onClick={() => setTab('ExpenseCategoryLimits')}
                                    role='tab'
                                >
                                    {/* {t('Expense Category Limits')} */}
                                    {getValueFromResource('Expense Category Limits',dispatch, t)}
                                </a>
                            </li>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'ExpensePolicyRules' })}
                                    onClick={() => setTab('ExpensePolicyRules')}
                                    role='tab'
                                >
                                    {/* {t('Expense Policy Rules')} */}
                                    {getValueFromResource('Expense Policy Rules',dispatch, t)}

                                </a>
                            </li>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'ExpensePolicyPerDiem' })}
                                    onClick={() => setTab('ExpensePolicyPerDiem')}
                                    role='tab'
                                >
                                   {/* {t('Expense Policy Per Diem')} */}
                                   {getValueFromResource('Expense Policy Per Diem',dispatch, t)}
                                </a>
                            </li>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'ExpensePolicyLockingExpenses' })}
                                    onClick={() => setTab('ExpensePolicyLockingExpenses')}
                                    role='tab'
                                >
                                   {/* {t('Locking Expense Entries')} */}
                                   {getValueFromResource('Locking Expense Entries',dispatch, t)}
                                </a>
                            </li>
                        </ul>
                    </div>
            <div className='tab-content pt-0'>
         <div className={clsx('tab-pane', { active: tab === 'ExpenseCategoryLimits' })}>
         <div className="card card-custom admin-policyCard">
         <div className="card-header sticky-top bg-white"  style={{marginLeft:'-10px'}} >
               <h3 className="card-title fw-bold mainHeading"  >
                {/* {t('General Limits')} */}
                {getValueFromResource('General Limits',dispatch, t)}
                </h3>
                </div>
                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                    <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle " >
                                    <th className='min-w-100%' style={{ textAlign: 'center' }}>
                                        {/* {t(`Expense Amount Limit`)} */}
                                        {getValueFromResource('Expense Amount Limit',dispatch, t)}
                                        </th>
                                    <th className='min-w-100%' style={{ textAlign: 'center' }}>
                                        {/* {t('Receipt Required Limit')} */}
                                        {getValueFromResource('Receipt Required Limit',dispatch, t)}
                                        </th>
                                    <th className='min-w-100%' style={{ textAlign: 'center' }}>
                                        {/* {t('Description Required')} */}
                                        {getValueFromResource('Description Required',dispatch, t)}
                                        </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                            {/* <td style={{ textAlign: 'center' }}>{tempObj['PolicyAmountLimit'] === null || tempObj['PolicyAmountLimit'] === undefined ? '0' : tempObj['PolicyAmountLimit']}</td> */}
                                               <td style={{ textAlign: 'center' }}>
                                                   {FormatInvoiceDecimalNumber(cultureInfoName.toString(), tempObj['PolicyAmountLimit'] ?? 0, decimalPlaces)}
                                               </td>

                           <td style={{ textAlign: 'center' }}>
                            {/* {tempObj['PolicyRequiredLimit'] === null || tempObj['PolicyRequiredLimit'] === undefined ? '0': tempObj['PolicyRequiredLimit']} */}
                             {FormatInvoiceDecimalNumber(cultureInfoName.toString(), tempObj['PolicyRequiredLimit'] ?? 0, decimalPlaces)}
                            </td>
                           <td style={{ textAlign: 'center' }}>{tempObj['PolicyDescriptionRequired'] == true ? 'Yes' : 'No'}</td>
                           <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onEditClick(expensePolicyDetailList[0].AccountExpensePolicyId) }} 
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>                                                                                                                                                         
                                                </Dropdown.Menu>
                                            </Dropdown>
                            </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
           
             <div className="custom-separator"></div>
                     <>
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white dropdown-zindex" style={{marginLeft:'-10px'}} >
                    <h3 className="card-title fw-bold headerTitle" >
                        {/* {t('Expense Category List')} */}
                        {getValueFromResource('Expense Category List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                          /> */}
                           <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                    </div>
                </div>
               
                    {/* <div className="card-body"> */}
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <ExpensePolicyDetailItem expensePolicyDetailList={currentItems} modelRef={modelRef} t={t} onopenModal={openModalPolicyCategory} oncloseModal={closeModalPolicyCategory} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
            </div>
            {isPolicyCategoryModalOpen &&
                <ExpensePolicyCategoryForm modelRef={modelRef} t={t} oncloseModal={closeModalPolicyCategory} />
            }
        </>
            </div>
            <div className={clsx('tab-pane', { active: tab === 'ExpensePolicyRules' })}  
            //onClick={() =>handleOnClickEvent(offCanvasList[0])}
            >
            <ExpensePolicyRule onhandleOnClickEvent={handleOnClickEvent}  ></ExpensePolicyRule>
            </div>
            <div className={clsx('tab-pane', { active: tab === 'ExpensePolicyPerDiem' })} >
                <ExpensePolicyPerDiem   onhandleOnClickEvent={handleOnClickEvent}  ></ExpensePolicyPerDiem>
            </div>
            <div className={clsx('tab-pane', { active: tab === 'ExpensePolicyLockingExpenses' })}>
                <ExpensePolicyLockingExpenses  ></ExpensePolicyLockingExpenses> 
            </div>
            
            </div>

               <ExpensePolicyDetailOffCanvas
                   isOpen={showOffCanvas}
                   onClose={() => setShowOffCanvas(false)}
                   obj={selectedOffCanvas}

               />
            {isGeneralLimitModalOpen &&
                <ExpensePolicyGeneralForm modelRef={modelRef} t={t} oncloseModal={closeModalGeneralLimit}/>
            }
        </>
    )

}

export default ExpensePolicyDetail;